import React from 'react';
import { Field, reduxForm } from 'redux-form';
import classNames from "classnames";
import { renderField, renderFieldCheck, renderSelectField } from "../../../Utils/renderField/renderField"
import IconCheck from '../../../../icons/check';
import { connect } from 'react-redux';


const renderRadioInput = (props) => {
    const {
        options = [],
        input,
        meta: { touched, error },
    } = props;

    const invalid = touched && error;

    return (
        <div>
            <div className={classNames("", {"is-invalid": invalid})}>
                {options.map((item, index) => (
                    <div className="d-flex align-items-center mb-1" key={index}>
                        <input
                            name={input.name}
                            type="radio"
                            value={item.value}
                            id={`${input.name}-opt-${index}`}
                            checked={input.value == item.value}
                            onChange={(e)=>input.onChange(e.target.value)}
                            className="mt-0"
                        />
                        <label
                            className="mb-0 fw-600 clickable"
                            htmlFor={`${input.name}-opt-${index}`}
                        >
                            {item.label}
                        </label>
                    </div>
                ))}
                {invalid && <div className="invalid-feedback">{error}</div>}
            </div>
        </div>
    )
}


const Form = (props) => {
    const {
        formValues = {},
        handleSubmit,
        onCancel,
        showPasswordField=true,
        showBtns=true,
        id,
    } = props;

    return (
        <form onSubmit={handleSubmit} id={id} className="d-flex flex-wrap">
            <div className="col-12 col-md-6">
                <div className="form-group">
                    <label htmlFor="first_name" className="fw-600">
                        First Name<span className="text-primary ml-1">*</span>
                    </label>
                    <Field
                        name="first_name"
                        component={renderField}
                        className=""
                        placeholder="First name"
                    />
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="form-group">
                    <label htmlFor="last_name" className="fw-600">
                        Last Name<span className="text-primary ml-1">*</span>
                    </label>
                    <Field
                        name="last_name"
                        component={renderField}
                        className=""
                        placeholder="Last name"
                    />
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="form-group">
                    <label htmlFor="email" className="fw-600">
                        Email<span className="text-primary ml-1">*</span>
                    </label>
                    <Field
                        name="email"
                        component={renderField}
                        className=""
                        placeholder="email@company.com"
                    />
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="form-group">
                    <label htmlFor="role" className="fw-600">
                        Role<span className="text-primary ml-1">*</span>
                    </label>
                    <Field
                        name="role"
                        component={renderSelectField}
                        options={[
                            {label: "Driver", value: "driver"},
                            {label: "Admin", value: "account_admin"}
                        ]}
                        className=""
                        inModal
                    />
                </div>
            </div>
            {formValues.role == 'account_admin' && (
                <div className="col-12">
                    <div className="form-group">
                        <Field
                            name="user_type"
                            component={renderRadioInput}
                            options={[
                                { label: "None", value: "admin" },
                                { label: "This admin is also a driver", value: "admin_driver" },
                                { label: "This admin is an owner operator", value: "owner_operator" },
                            ]}
                        />
                    </div>
                </div>
            )}
            <div className="col-12 col-md-6">
                <div className="form-group">
                    <label htmlFor="mobile_phone" className="fw-600">
                        Phone
                    </label>
                    <Field
                        name="mobile_phone"
                        component={renderField}
                        className=""
                        placeholder="555-0100"
                    />
                </div>
            </div>
            {showPasswordField && (
                <div className="col-12 col-md-6">
                    <div className="form-group">
                        <label htmlFor="password" className="fw-600">
                            Password
                        </label>
                        <Field
                            name="auto_generate"
                            component={renderFieldCheck}
                            label="Auto-generate password"
                        />
                        {!formValues.auto_generate && (
                            <Field
                                name="password"
                                component={renderField}
                                className=""
                                placeholder="Enter custom password"
                            />
                        )}
                    </div>
                </div>
            )}
            {showBtns && (
                <div className="col-12 d-flex justify-content-end">
                    <button type="button"
                        className="btn btn-outline-secondary px-4 py-2 m-1"
                        onClick={onCancel}
                    >
                        <span className="fw-600">
                            Cancel
                        </span>
                    </button>
                    <button type="submit" className="btn btn-primary px-4 py-2 m-1">
                        <IconCheck className="smallIcon" />
                        <span className="ml-2 fw-600">
                            Send Invite
                        </span>
                    </button>
                </div>
            )}
        </form>
    )
}

const DriverForm = reduxForm({
    form: "driverForm",
    validate: (data, { formValues = {} }) => {
        const errors = {};
        if (!data.email) errors.email = "Required Field";
        else if(!/^\S+@\S+\.\S+$/.test(data.email))
            errors.email = "Please enter a valid email address."
        if (!data.first_name) errors.first_name = "Required Field";
        if (!data.last_name) errors.last_name = "Required Field";
        if (!data.role) errors.role = "Required Field";
        if (!formValues.auto_generate && !data.password)
            errors.password = "Required Field";

        return errors;
    }
})(Form);

const mstp = (state) => ({
    formValues: state.form && state.form.driverForm && state.form.driverForm.values
})

export default connect(mstp)(DriverForm);

